// @flow
import type { State } from "@store/reducers";
import type {
  DynamicQuestion,
  DynamicQuestionContent,
} from "@modules/service/reducer/dynamic-questions/types";
import type { HierarchyAssignment } from "@modules/service/types";
import { removeNullAndUndefinedProps } from "@transformers/object";
import Ajv from "ajv";
import { validateHierarchyAssignmentSchema } from "./index";

export const getDynamicQuestionsList = (state: State): Array<DynamicQuestion> =>
  state.service.dynamicQuestions.list.content;

export const getDynamicQuestionContainer = (state: State): ?DynamicQuestion =>
  state.service.dynamicQuestions.current;

export const getDynamicQuestionDraft = (state: State): ?DynamicQuestionContent =>
  state.service.dynamicQuestions.draft;

export const isDynamicQuestionDraftValid = (state: State): boolean => {
  const schema = getDynamicQuestionRevisionSchema(state);
  const draft = state.service.dynamicQuestions.draft;
  if (!schema || !draft) {
    return false;
  }
  return new Ajv().validate(schema, removeNullAndUndefinedProps(draft));
};

// MODALS
export const getShowAddDynamicQuestionModal = (state: State): boolean =>
  state.service.dynamicQuestions.modals.showAddDynamicQuestionModal;

export const getShowEditDynamicQuestionModal = (state: State): boolean =>
  state.service.dynamicQuestions.modals.showEditModal;

export const getDynamicQuestionsModalStep = (state: State): number =>
  state.service.dynamicQuestions.modals.modalStep;

export const getDynamicQuestionRevisionSchema = (state: State) =>
  state.service.dynamicQuestions.schema;

export const getDynamicQuestionAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.dynamicQuestions.assignments;

export const getDynamicQuestionDraftAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.dynamicQuestions.draftAssignments;

export const isDynamicQuestionDraftAssignmentsValid = (state: State): boolean => {
  const assignments = getDynamicQuestionDraftAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const isDynamicQuestionAssignmentsValid = (state: State): boolean => {
  const assignments = getDynamicQuestionAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const getShowDynamicQuestionEditAssignmentModal = (state: State): boolean =>
  state.service.dynamicQuestions.modals.showEditAssignmentsModal;
